import { gql } from '@apollo/client';

export const GET_INVITE_INFO_QUERY = gql`
  query parseInviteToken($token: String!) {
    parseInviteToken(token: $token) {
      invitee
      inviter: target
      linkAccountActionType
    }
  }
`;

// this is for logged user
export const ACCEPT_LINK_MUTATION = gql`
  mutation acceptLink($token: String!) {
    acceptInvite(token: $token)
  }
`;

// this is for not_logged user, they need to create account
export const ACCEPT_CREATE_AND_LINK_MUTATION = gql`
  mutation acceptCreateAndLink($token: String!, $password: String!) {
    acceptInviteLink(token: $token, password: $password)
  }
`;
